import { useEffect, useState } from "react";

interface IProps {
  src?: any,
  alt?: any,
  fallbackSrc?: any,
  'data-attribute'?: any,
  [key: string]: any,
}

const Index = ({ src, alt, fallbackSrc, ...props }: IProps) => {
  const [actualSrc, setActualSrc] = useState<string>(src);
  const [errored, setErrored] = useState<boolean>(false);

  useEffect(() => {
    setActualSrc(src)
  }, [src])
  const onError = () => {
    if (!errored) {
      setErrored(true);
      setActualSrc(fallbackSrc);
    }
  };

  return <img src={actualSrc} alt={alt} onError={onError} {...props} />;
};

export default Index;
